import { List, ListItem, ListItemText } from "@mui/material"

export function FeatureFlagDescription() {
    return (
        <List disablePadding>
            <ListItem
                sx={{
                    p: 0,
                    pb: 1,
                }}
            >
                <ListItemText
                    primary={`\u2022 Enables clients to download maintenance regimes as XML via a sharing link.`}
                />
            </ListItem>
            <ListItem
                sx={{
                    p: 0,
                    pb: 1,
                }}
            >
                <ListItemText primary={`\u2022 This feature is available via the add on product FIQXML.`} />
            </ListItem>
        </List>
    )
}
